import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import logo from '../../assets/img/logo-colorido-0160.png';
import { useAuth } from "../../hooks/useAuth";

const Login: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated, login } = useAuth();
    
    const urlParams = new URLSearchParams(location.search);
    const redirectParam = urlParams.get('redirect');
    const from = redirectParam ? decodeURIComponent(redirectParam) : '/';

    useEffect(() => {
        if (isAuthenticated) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, navigate, from]);

    const logarKeycloak = () => {
        login(from);
    };

    return (
        <Container fluid className="bg-light" style={{ textAlign: 'center', fontSize: 12, color: '#8391A2', height: '100%', display: 'flex', flexDirection:'column' }}>
            <div className="py-3 py-md-5">
                <div className="container">
                    <div className="row justify-content-md-center">
                        <div className="col-12 col-md-11 col-lg-8 col-xl-7 col-xxl-6">
                            <div className="bg-white p-4 p-md-5 rounded shadow-sm">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="text-center mb-5">
                                            <div className="col-12 fs-5" style={{ marginTop: '15px', color: 'black' }}>
                                                <a href="https://www.unicamp.br/">
                                                    <img src={logo} alt="BootstrapBrain Logo" style={{ marginBottom: '35px' }} />
                                                </a>
                                                <h1><strong>Identifica</strong></h1>
                                            </div>
                                            <div className="col-12 fs-2" style={{ marginTop: '45px' }}>
                                                Sistema de Heteroidentificação de Cotas Étnico-Raciais
                                            </div>
                                            <div className="col-12 fs-5" style={{ marginTop: '15px' }}>
                                                Para acessar o serviço é preciso prosseguir através <br />
                                                do Sistema de Autenticação Central da UNICAMP.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gy-3 gy-md-4 overflow-hidden" >
                                    <div className="col-12">
                                        <div className="d-grid">
                                            <button className="btn btn-dark btn-lg" type="submit" onClick={logarKeycloak} autoFocus={true}>
                                                ACESSAR SISTEMA
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <hr className="mt-5 mb-4 border-secondary-subtle" />
                                        <div className="row justify-content-center">
                                            <div className="col-md-4 text-center mb-2 mb-md-0">
                                                <a href="https://www.direitoshumanos.unicamp.br/"
                                                    className="link-secondary text-decoration-none">
                                                    Diretoria Executiva de Direitos Humanos
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="https://detic.unicamp.br/"
                className="link-secondary text-decoration-none">
                Desenvolvido por 
            </a>
            <a href="https://detic.unicamp.br/"
                className="link-secondary text-decoration-none">
                Diretoria Executiva de Tecnologia da Informação e Comunicação (DETIC)
            </a>
        </Container>
    );
}

export default Login;